import type { Enums } from "@msuite/utils/types";
import { useTableTypes } from "@/hooks/use-table-types";

/**
 * This hook is used as a wrapper to call the api endpoint to get the ticket types.
 * @returns
 */
export function useTicketTypes(state: Enums<"ticketTypeState">[] = ["active"]) {
	/** Hooks */

	/** Query */
	const t = useTableTypes("ticketTypes", state);
	return t;
}
